import { render, staticRenderFns } from "./MpChooseAnswerV2.vue?vue&type=template&id=7e90e983&scoped=true&"
import script from "./MpChooseAnswerV2.vue?vue&type=script&lang=js&"
export * from "./MpChooseAnswerV2.vue?vue&type=script&lang=js&"
import style0 from "./MpChooseAnswerV2.vue?vue&type=style&index=0&id=7e90e983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90e983",
  null
  
)

export default component.exports